import { useTranslation } from 'react-i18next'
import { CtaWithBackground } from '@velasca/ui/cta-with-background'
import { SansText } from '@velasca/ui/sans-text'
import { Separator } from '@velasca/ui/separator'
import { Content, Ctas } from './EmptyCart.styles'
import type { EmptyCartProps } from './EmptyCart.types'

export const EmptyCart = ({ emptyCartCtas }: EmptyCartProps) => {
  const { t } = useTranslation('cartDrawer')

  return (
    <Content>
      <SansText center margin="1.2rem 2.4rem 2.4rem 2.4rem" size="md">
        {t('cart_drawer_empty_cart')}
      </SansText>
      <Separator />
      <Ctas>
        {emptyCartCtas.map((cta) => {
          const { image, text, url } = cta

          if (!image) {
            return null
          }

          return (
            <CtaWithBackground key={url} image={image} text={text} url={url} />
          )
        })}
      </Ctas>
    </Content>
  )
}
